import { IAdjustment2Option, IAdjustmentBuyBase } from "./deltaHedgeAdjustment";
import { ISearchParameters, ITableReport } from "./TableInterfaces";

export interface IDeltaHedgeExeCommonSearchParam {
  user?: number[];
  ins: string;
}

export interface IDeltaProccessSahraOrderSearchParam {
  user?: number;
  ins: string;
  processId: string;
}

export interface IUserInsReport extends ITableReport {}

export interface IInsReport extends ITableReport {}
export interface IIncrementalReport extends ITableReport {
  ins: string;
  user: number[];
}

export interface IDecrementalReport extends ITableReport {
  ins: string;
  user: number[];
}

export interface IErrorReport extends ITableReport {}
export interface IDeltaReport extends ITableReport {}
export interface IConversionReport extends ITableReport {}
export interface IDetailProcessReport extends ITableReport {
  processId: string;
}
export interface IDetailProcessSahraOrderReport extends ITableReport {}

export interface IDeltaHedgeExeBaseConfig {
  incDeltaDecGamma: IAdjustment2Option;
  decDeltaDecGamma: IAdjustment2Option;
  decDeltaIncGamma: IAdjustment2Option;
  incDeltaIncGamma: IAdjustment2Option;
}
export interface IDeltaHedgeExeCommonConfigDTO extends IDeltaHedgeExeBaseConfig {
  goalDeltaTolerance: number;
  goalGammaTolerance: number;
}

export interface IDeltaHedgeExeAdjustmentFromCentralConfigDTO {
  goalDeltaTolerance: number;
  incDelta: IAdjustment2Option;
  decDelta: IAdjustment2Option;
}

export interface IDeltaHedgeExeEmergancyConfig {
  goalDeltaTolerance: number;
  incDelta: IDeltaHedgeExeEmergancyOption;
  decDelta: IDeltaHedgeExeEmergancyOption;
}

export interface IDeltaHedgeExeEmergancyOption {
  minAbsDiffrential: number;
  minAbsDelta: number;
  minLastTrade: number;
  minRemainingDay: number;
  maxRemainingDay: number;
  relativeNormalBubbleTreshold: number;
  minDailyLockProfitDifferentWeak: number;
  minDailyLockProfitDifferentApplyDay: number;
  minDailyLockProfitDifferentKind: number;
  minDailyLockProfitSameKind: number;
  minDailyLockProfitReinforcement: number;
}

export interface IDeltaHedgeExeManagementTableSearchParam extends ISearchParameters {
  accountIds: string[];
  groupIds: string[];
}

export interface IDeltaHedgeExeManagementTableReport extends ITableReport {
  userId: number;
  groupId: number;
  targetDeltaPercent: string;
  targetDelta: number;
  targetGammaPercent: string;
  targetGamma: number;
  deltaUnitPercent: number;
  gammaUnitPercent: number;
  adjustment: boolean;
  strategyId: string;
  adjustmentType: IAdjustmentType;
}

export interface IDeltaHedgeExeManagementAddEditTaskDTO {
  id?: number;
  accountIds: number[];
  groupIds: number[];
  targetDeltaPercent: number;
  targetGammaPercent: number;
  deltaTolerancePercent: number;
  gammaTolerancePercent: number;
  strategyId: string;
  adjustmentType: IAdjustmentType;
}

export interface IDeltaHedgeExeTradeSearchParam extends ISearchParameters {
  accountId: number;
  openVolumeOnly: boolean;
  id: number;
}

export interface IDeltaHedgeExeTradeTableReport extends ITableReport {}

export interface IExeTime {
  startTime: string;
  startTimeISO: string;
  endTime: string;
  endTimeISO: string;
  treshold: string;
  delay: number;
  maxHedgePercent: number;
  maxHedgeValue: number;
  minEnteringPricePercent: number;
  minEnteringPriceValue: number;
  orderVolumeMax: number;
  orderValueMax: number;
}

export interface IExeTimeDTO {
  adjustment: IExeTime;
}

export interface IAllowedTradesSearchParam extends ISearchParameters {
  processEnum: string;
  strategyEnum: string;
}
export interface IAllowedTradesTableReport extends ITableReport {}

export enum DeltaHedgeExeProcess {
  Adjustment = "Adjustment",
}

export interface IDeltaHedgeExeDetailedStateTableSearchParam extends ISearchParameters {
  accountId: number;
  groupId: number;
  deltahedgeAccountId: number;
}

export interface IDeltaHedgeExeDetailedStateTableReport extends ITableReport {
  deltaPercent: number;
  gammaPercent: number;
  targetGamma: number;
  targetDelta: number;
  accountId: number;
  deltahedgeAccountId: number;
}

export interface IDeltaHedgeExeDetailedStateTradeTableSearchParam extends ISearchParameters {
  taskId: number;
  id: number;
}

export interface IDeltaHedgeExeDetailedStateAdjustmentStateTableSearchParam extends ISearchParameters {
  id: number;
}

export interface IDetailedStateAdjustmentTablesSearchParam extends ISearchParameters {
  groupId: number;
  accountId: number;
  id: number;
  userPoint: {
    delta: number;
    gamma: number;
  };
  incDelta: boolean;
  incGamma: boolean | null;
  deltahedgeAccountId: number;
}

export interface IReferenceTableReport extends ITableReport {
  buy: string;
  buyInsCode: string;
  buyInsId: string;
  dailyLockProfitPercent: string;
  id: number;
  ref: string;
  row: number;
  selectType: number;
  selectTypeStr: string;
  sell: string;
  sellInsCode: string;
  sellInsId: string;
}

export interface IDeltaHedgeExeStrategy {
  name: string;
  id?: string;
}

export enum IAdjustmentType {
  OffsetPlusAll = 1,
  OffsetPlusProperty = 2,
  Offset = 3,
}
